<template>
  <!-- 右侧列表相关链接 -->
  <div class="card-right">
    <el-card shadow="never" style="width: 332px; height: 100%">
      <div class="right-list">
        <div class="list-title" style="margin-bottom: 10px">
          <h3 style="color: #a19b5a">| 相关列表快速链接</h3>
        </div>
        <el-menu default-active="1" class="menu-border">
          <el-menu-item
            :class="[
              MemberManagementRightSelect == index + 1 ? 'IsSelect' : '',
            ]"
            @click="GetNavgetToUrl(item.url, index + 1)"
            v-for="(item, index) in PagesData"
            :key="index"
            class="right-item"
          >
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </el-menu>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    RightIndex: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      PagesData: [
        {
          title: "客户交易记录",
          url: "/Transactions",
        },
        {
          title: "客户购买商品清单",
          url: "/ShoppingList",
        },
        {
          title: "会员劵",
          url: "/MembershipVolume",
        },
        {
          title: "券转赠记录",
          url: "/VoucherTransferRecord",
        },
        {
          title: "积分明细",
          url: "/Integrate",
        },
        {
          title: "兑换记录",
          url: "/ExchangeRecord",
        },
        {
          title: "礼品领用记录",
          url: "/GetGiftList",
        },
        {
          title: "客户心愿单",
          url: "/WishList",
        },
        {
          title: "客户等级变更历史",
          url: "/LevelChange",
        },
        {
          title: "关键信息变更历史",
          url: "/InfoLevelChange",
        },
        {
          title: "会员特殊日期",
          url: "/Membership",
        },
        {
          title: "会员预约",
          url: "/Appointment",
        },
        {
          title: "会员关系",
          url: "/Customer",
        },
        {
          title: "客户维护记录",
          url: "/Record",
        },
        {
          title: "改衣单记录",
          url: "/Single",
        },
        {
          title: "会员地址",
          url: "/Address",
        },
      ],
    };
  },
  watch: {
    $route: {
      immediate: true, // 一旦监听到路由的变化立即执行
      handler(to) {
        const SuccessRouter = [
          "Transactions",
          "ShoppingList",
          "MembershipVolume",
          "VoucherTransferRecord",
          "Integrate",
          "ExchangeRecord",
          "GetGiftList",
          "WishList",
          "LevelChange",
          "InfoLevelChange",
          "Membership",
          "Appointment",
          "Customer",
          "Record",
          "Single",
          "Address",
        ];
        if (!SuccessRouter.includes(JSON.parse(JSON.stringify(to.name)))) {
          this.$store.dispatch("user/USetMemberManagementRightSelect", "");
        }
      },
    },
  },
  computed: {
    ...mapState({
      MemberManagementRightSelect: (state) =>
        state.user.MemberManagementRightSelect,
    }),
  },
  methods: {
    GetNavgetToUrl(url, index) {
      this.$store.dispatch("user/USetMemberManagementRightSelect", index);
      this.$router.push(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.right-item:last-of-type {
  border-bottom: 1px solid #ccc;
}
.right-item {
  border: 1px solid #ccc;
  border-bottom: none;
}
.IsSelect {
  background: #f5f3e0;
  color: #6c6839;
}
/deep/ {
  /* 改变elementui 侧边栏移入颜色 */
  .el-menu-item:hover {
    background: #f5f3e0;
    color: #6c6839;
  }
  .el-submenu__title:hover {
    background: #f5f3e0;
    color: #6c6839;
  }
  .el-menu-item.is-active {
    background: #f5f3e0;
    color: #6c6839;
  }
  .el-submenu__title.is-active {
    background: #f5f3e0;
    color: #6c6839;
  }
}
</style>
